import { useEffect, useState } from 'react';
import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import { ComponentProps } from '@gn-audio/jss-components';
import { DEFAULT_SC_LOCALE } from '@gn-audio/jss-core/common/constants/locales.const';

type CookiePolicyProps = {
  fields: {
    header: Field<string>;
    cookiePolicyContentUrl: Field<string>;
  };
} & ComponentProps;

const SCRIPT_ID = 'CookieDeclaration';
const SCRIPT_CONTAINER_ID = 'CookieDeclarationContainer';

const getLanguageCode = (languageString: string): string => {
  return languageString?.split('-')[0] || '';
};

const CookiePolicy = ({ fields }: CookiePolicyProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const { sitecoreContext } = useSitecoreContext();
  const { header, cookiePolicyContentUrl } = fields;

  const languageCode = getLanguageCode(sitecoreContext.language || DEFAULT_SC_LOCALE);
  const encodedContentUrl = encodeURI(cookiePolicyContentUrl?.value || '');

  useEffect(() => {
    const scriptContainer = document.getElementById(SCRIPT_CONTAINER_ID);
    const script = document.createElement('script');
    script.src = encodedContentUrl;
    script.async = true;
    script.onload = () => setIsLoading(false);
    script.onerror = () => {
      setIsLoading(false);
      console.warn('Error loading cookie policy script');
    };
    script.setAttribute('data-culture', languageCode);
    script.id = SCRIPT_ID;

    if (scriptContainer) {
      scriptContainer.replaceChildren(script);
    }

    return () => {
      const existingScript = document.getElementById(SCRIPT_ID);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [encodedContentUrl, languageCode]);

  return (
    <div className="container">
      <header>
        <h1 className="heading-1">{header?.value}</h1>
      </header>
      <div className="flex w-full justify-center py-2">
        {isLoading && (
          <div className="flex w-full flex-col gap-3">
            <span className="animate-glow">x xxx</span>
            <span className="animate-glow w-4/5">x xxx</span>
            <span className="animate-glow w-3/4">x xxx</span>
            <span className="animate-glow w-1/5">x xxx</span>
            <span className="animate-glow w-2/3">x xxx</span>
            <span className="animate-glow w-1/4">x xxx</span>
            <span className="animate-glow w-3/4">x xxx</span>
          </div>
        )}
        <div id={SCRIPT_CONTAINER_ID} className="overflow-x-auto" />
      </div>
    </div>
  );
};

export default withDatasourceCheck()(CookiePolicy);
